import app_config from "../app_config.json";

export class Defaults {
  private static instance: Defaults;

  private constructor() {}

  static getInstance(): Defaults {
    if (!this.instance) {
      this.instance = new Defaults();
    }
    return this.instance;
  }

  get progressiveDiscount() {
    return 4.5;
  }

  get processingFee() {
    return 5;
  }

  get promoCode() {
    return app_config.wag_api.promo_code;
  }

  get userType() {
    return app_config.wag_api.user_type;
  }

  get productCode() {
    return app_config.wag_api.product_code;
  }

  get coverageType() {
    return app_config.wag_api.coverage_type;
  }

  get policyState() {
    return app_config.wag_api.policy_state;
  }

  get customerId() {
    return app_config.wag_api.customer_id;
  }

  get apiKey() {
    return app_config.wag_api.api_key;
  }
}
